exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-manager-main-container .detailsView{font-family:Open Sans,sans-serif!important}.cookie-manager-main-container .detailsView .cookie-custom-checkbox{padding-right:15px}.cookie-manager-main-container .detailsView .basic{margin-top:18px}.cookie-manager-main-container .detailsView .btn-primary{border:none}.cookie-manager-main-container .detailsView .modal-footer{display:block}.cookie-manager-main-container .btn.accept-cookie-btn{background-color:#17694b!important;border:2px solid #32d69a!important;height:32px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--2-2!./node_modules/sass-loader/lib/loader.js!./src-cookie-manager/views/pages/details/style.scss
// module id = 439
// module chunks = 0